<div class="login-page" [class.login-page--handoff]="handingOff">
  <!-- Left: form -->
  <div class="login-panel">
    <div class="login-panel-inner">
      <div class="login-logo">
        <img alt="Snöball" src="../../../assets/images/blue-logo.png" />
      </div>

      <h1 class="login-welcome">{{ 'Loginpage.welcome_back' | translate }}</h1>

      @if (submitted && !authMessage['Success'] && authMessage['msg']) {
      <div
        class="login-alert login-alert--error"
      >
        <p>{{ authMessage['msg'] }}</p>
      </div>
      }
      @if (ssoError) {
      <div class="login-alert login-alert--error login-sso-error" role="alert">
        <p class="login-sso-error__text">{{ ssoError }}</p>
      </div>
      }
      @if (successTokenUrl) {
      <div class="login-alert login-alert--success">
        <p>{{ 'Loginpage.account_verified' | translate }}</p>
      </div>
      }

      @if (authFlow?.code === 'AUTH_ACCOUNT_RESTRICTED') {
      <div class="login-alert login-alert--error">
        <p>{{ authFlow.message || ('AuthSecurity.account_restricted' | translate) }}</p>
      </div>
      }
      @if (authFlow?.code === 'AUTH_ACCOUNT_SUSPENDED') {
      <div class="login-alert login-alert--error">
        <p>{{ authFlow.message }}</p>
        <small>{{ 'AuthSecurity.suspended' | translate }} {{ authFlow.suspended_at | date:'medium' }} · {{ authFlow.reason }}</small>
      </div>
      }
      @if (authFlow?.code === 'AUTH_CAPTCHA_REQUIRED') {
      <div class="login-alert login-alert--error">
        <p>{{ authFlow.message || ('AuthSecurity.auth_failed' | translate) }}</p>
        @if (!captchaUnavailable) {
        <small>{{ 'AuthSecurity.captcha_required' | translate }}</small>
        }
        @if (captchaUnavailable) {
        <small>{{ 'AuthSecurity.captcha_unavailable' | translate }}</small>
        }
      </div>
      }
      @if (authFlow?.code === 'AUTH_ACCOUNT_LOCKED') {
      <div class="login-alert login-alert--error">
        <p>{{ (authFlow.permanent ? 'AuthSecurity.account_locked_permanently' : 'AuthSecurity.account_locked') | translate }}</p>
        @if (!authFlow.permanent && authFlow.locked_until) {
        <small>
          {{ 'AuthSecurity.account_locked_until' | translate:{date: (authFlow.locked_until | date:'medium')} }}
        </small>
        }
      </div>
      }
      @if (authFlow && !['AUTH_ACCOUNT_RESTRICTED', 'AUTH_ACCOUNT_SUSPENDED', 'AUTH_ACCOUNT_LOCKED', 'AUTH_CAPTCHA_REQUIRED',
        'AUTH_MFA_REQUIRED', 'AUTH_SESSION_CONFLICT', 'AUTH_MFA_ENROLLMENT_REQUIRED'].includes(authFlow.code)) {
<div
        class="login-alert login-alert--error">
        <p>{{ authFlow.message || ('AuthSecurity.auth_failed' | translate) }}</p>
      </div>
}

      @if (authFlow?.code === 'AUTH_MFA_REQUIRED') {
      <div class="login-form">
        @if (!recoveryMode && authFlow.methods?.length > 1) {
        <div class="mb-3">
          <label class="login-field-label" for="mfa-method">{{ 'AuthSecurity.verification_method' | translate }}</label>
          <select id="mfa-method" class="login-input" [(ngModel)]="mfaMethod"
            [ngModelOptions]="{standalone: true}">
            @if (authFlow.methods.includes('totp')) {
            <option value="totp">{{ 'AuthSecurity.authenticator' | translate }}</option>
            }
            @if (authFlow.methods.includes('email')) {
            <option value="email">{{ 'AuthSecurity.email_weaker' | translate }}</option>
            }
          </select>
        </div>
        }
        @if (!recoveryMode && mfaMethod === 'email' && !emailCodeSent) {
        <button
          class="btn btn-outline-primary mb-3" type="button" (click)="sendEmailMfaCode()">
          {{ 'AuthSecurity.send_email_code' | translate }}
        </button>
        }
        <label class="login-field-label" for="mfa-code">{{ 'AuthSecurity.verification_code' | translate }}</label>
        <input id="mfa-code" class="login-input" [ngModel]="mfaCode" (ngModelChange)="onMfaCodeInput($event)"
          [ngModelOptions]="{standalone: true}"
          autocomplete="one-time-code" inputmode="numeric" />
        @if (authFlow.methods?.includes('recovery_code')) {
        <label class="login-remember mt-2">
          <input class="login-checkbox" type="checkbox" [(ngModel)]="recoveryMode"
            [ngModelOptions]="{standalone: true}" />
          <span>{{ 'AuthSecurity.use_recovery' | translate }}</span>
        </label>
        }
        @if (!recoveryMode && rememberDeviceDays > 0) {
        <label class="login-remember mt-2">
          <input class="login-checkbox" type="checkbox" [(ngModel)]="rememberMfaDevice"
            [ngModelOptions]="{standalone: true}" />
          <span>{{ 'AuthSecurity.trust_device' | translate }}</span>
        </label>
        }
        <button class="login-submit mt-3" type="button" (click)="completeMfa()">{{ 'AuthSecurity.verify' | translate }}</button>
      </div>
      }

      @if (authFlow?.code === 'AUTH_SESSION_CONFLICT') {
      <div class="login-form">
        <p>{{ 'AuthSecurity.session_limit' | translate:{count: authFlow.maximum_active_sessions || 1} }}</p>
        @if (authFlow.existing_sessions?.length) {
        <ul class="login-session-list">
          @for (session of authFlow.existing_sessions; track session) {
          <li>
            {{ 'AuthSecurity.session_active_since' | translate:{browser: session.browser, date: (session.last_used_at | date:'medium')} }}
          </li>
          }
        </ul>
        }
        <button class="login-submit" type="button" (click)="replaceSession()">
          {{ 'AuthSecurity.replace_oldest' | translate }}
        </button>
      </div>
      }

      @if (authFlow?.code === 'AUTH_MFA_ENROLLMENT_REQUIRED') {
      <div class="login-form">
        @if (enrollmentFinishing) {
        <button class="login-submit" type="button" disabled aria-busy="true">
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
          <span>{{ 'Loginpage.logging_in' | translate }}</span>
        </button>
        }
        @if (!enrollmentFinishing && !totpEnrollment && !emailEnrollment && !recoveryCodesReady) {
          <p>{{ 'AuthSecurity.choose_mfa' | translate }}</p>
          @if (mfaAvailableMethods.includes('totp')) {
          <button class="login-submit mb-2"
            type="button" (click)="startTotpEnrollment()">{{ 'AuthSecurity.authenticator' | translate }}</button>
          }
          @if (mfaAvailableMethods.includes('email')) {
          <button class="login-submit"
            type="button" (click)="startEmailEnrollment()">{{ 'AuthSecurity.email_weaker' | translate }}</button>
          }
          @if (authFlow?.mfa_reminder_deferrable) {
          <button class="login-link mt-3"
            type="button" [disabled]="enrollmentSkipping" (click)="skipEnrollment()">
            {{ 'AuthSecurity.mfa_nudge_skip_week' | translate:{days: authFlow.mfa_reminder_deferral_days || 7} }}
          </button>
          }
          @if (authFlow?.mfa_reminder_deferrable) {
          <small class="d-block mt-1 text-muted">
            {{ 'AuthSecurity.mfa_enrollment_skips_left' | translate:{count: authFlow.mfa_reminder_deferrals_left} }}
          </small>
          }
        }
        @if (totpEnrollment && !recoveryCodesReady) {
          <p>{{ 'AuthSecurity.add_authenticator' | translate }}</p>
          @if (totpEnrollment.qr_data_uri) {
          <img [src]="totpEnrollment.qr_data_uri"
            alt="Authenticator QR code" class="d-block mx-auto mb-3" width="240" height="240" />
          }
          <code class="d-block text-break mb-2">{{ totpEnrollment.secret }}</code>
          <small class="d-block text-break mb-3">{{ totpEnrollment.provisioning_uri }}</small>
          <label class="login-field-label" for="totp-confirm-code">{{ 'AuthSecurity.authenticator_code' | translate }}</label>
          <input id="totp-confirm-code" class="login-input" [ngModel]="mfaCode"
            [class.login-input--invalid]="mfaEnrollmentError"
            [ngModelOptions]="{standalone: true}" autocomplete="one-time-code" inputmode="numeric"
            type="text" [attr.minlength]="totpDigits"
            [attr.pattern]="'[0-9]{' + totpDigits + '}'" (ngModelChange)="onMfaCodeInput($event); mfaEnrollmentError = ''" />
          @if (mfaEnrollmentError) {
          <div class="login-field-error" role="alert" aria-live="polite">
            {{mfaEnrollmentError}}
          </div>
          }
          <small class="d-block mt-2">
            {{ 'AuthSecurity.totp_code_format' | translate:{count: totpDigits} }}
          </small>
          <button class="login-submit mt-3" type="button" [disabled]="totpConfirming"
            (click)="confirmTotp()">{{ 'AuthSecurity.confirm_mfa' | translate }}</button>
        }
        @if (emailEnrollment) {
          <p>{{ 'AuthSecurity.email_code_sent' | translate }}</p>
          <label class="login-field-label" for="email-enrollment-code">{{ 'AuthSecurity.email_code' | translate }}</label>
          <input id="email-enrollment-code" class="login-input" [ngModel]="mfaCode"
            (ngModelChange)="onMfaCodeInput($event)"
            [ngModelOptions]="{standalone: true}" autocomplete="one-time-code" inputmode="numeric" />
          <button class="login-submit mt-3" type="button"
            (click)="confirmEmailEnrollment()">{{ 'AuthSecurity.confirm_email' | translate }}</button>
        }
        @if (recoveryCodesReady) {
          <p>{{ 'AuthSecurity.save_recovery' | translate }}</p>
          <div class="alert alert-warning">
            {{ 'AuthSecurity.recovery_download_only' | translate }}
          </div>
          <button class="login-submit mt-3" type="button" (click)="downloadRecoveryCodes()">
            {{ 'AuthSecurity.download_recovery' | translate }}
          </button>
          <label class="login-remember mt-3">
            <input class="login-checkbox" type="checkbox" [(ngModel)]="recoveryCodesAcknowledged"
              [ngModelOptions]="{standalone: true}" />
            <span>{{ 'AuthSecurity.saved_recovery' | translate }}</span>
          </label>
          <button class="login-submit mt-3" type="button" [disabled]="!recoveryCodesAcknowledged"
            (click)="finishEnrollment()">{{ 'AuthSecurity.continue' | translate }}</button>
        }
      </div>
      }

      @if (!authFlow || authFlow.code === 'AUTH_CAPTCHA_REQUIRED' || authFlow.code === 'AUTH_ACCOUNT_RESTRICTED') {
      <form
        (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="login-form">
        <label class="login-field-label" for="login-email">{{ 'Loginpage.email' | translate }}</label>
        <input
          id="login-email"
          class="login-input"
          [class.login-input--invalid]="submitted && f.email.errors"
          formControlName="email"
          [placeholder]="'Loginpage.email_placeholder' | translate"
          type="email"
          autocomplete="username"
          (blur)="onEmailBlur()"
        />
        @if (submitted && f.email.errors) {
        <div class="login-field-error">
          @if (f.email.errors.required) {
          <span>{{ 'Loginpage.email_require' | translate }}</span>
          }
          @if (f.email.errors.email) {
          <span>{{ 'Loginpage.valid_email' | translate }}</span>
          }
        </div>
        }

        <label class="login-field-label" for="login-password">{{ 'Loginpage.password' | translate }}</label>
        <input
          id="login-password"
          class="login-input"
          [class.login-input--invalid]="submitted && f.password.errors"
          formControlName="password"
          [placeholder]="'Loginpage.password_placeholder' | translate"
          type="password"
          autocomplete="current-password"
        />
        @if (submitted && f.password.errors) {
        <div class="login-field-error">
          @if (f.password.errors.required) {
          <span>{{ 'Loginpage.password_require' | translate }}</span>
          }
          @if (f.password.errors.minlength) {
          <span>{{ 'Loginpage.valid_password' | translate }}</span>
          }
        </div>
        }

        <div class="login-row">
          <label class="login-remember">
            <input class="login-checkbox" formControlName="remember" type="checkbox" />
            <span>{{ 'Loginpage.remember_me' | translate }}</span>
          </label>
          <a class="login-forgot" routerLink="/password">{{ 'Loginpage.forgot' | translate }}</a>
        </div>

        @if (authFlow?.code === 'AUTH_CAPTCHA_REQUIRED') {
        <div id="login-turnstile" class="mb-3"></div>
        }

        <button class="login-submit" type="submit" [disabled]="loginSubmitDisabled"
                [attr.aria-busy]="loginPending || handingOff || captchaPending">
          @if (loginPending || handingOff || captchaPending) {
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
          }
          @if (loginPending || handingOff) {
          <span>{{ 'Loginpage.logging_in' | translate }}</span>
          }
          @if (!loginPending && !handingOff && captchaPending) {
          <span>{{ 'Loginpage.captcha_waiting' | translate }}</span>
          }
          @if (!loginPending && !handingOff && !captchaPending) {
          <span>{{ 'Loginpage.login' | translate }}</span>
          }
        </button>

        @if (ssoDiscover?.ssoEnabled) {
        <button
          class="login-submit login-submit--sso mt-2"
          [class.login-submit--sso-recommended]="ssoDiscover?.recommended"
          type="button"
          (click)="continueWithSso()"
          [disabled]="ssoDiscoverLoading"
        >
          <span>{{ 'AuthSecurity.continue_sso' | translate }}</span>
          @if (ssoDiscover?.recommended) {
          <span class="login-sso-recommended-badge">
            {{ 'AuthSecurity.recommended' | translate }}
          </span>
          }
        </button>
        }
        @if (ssoDiscover?.recommended) {
        <p class="login-sso-recommended-copy">
          {{ 'AuthSecurity.sso_recommended' | translate }}
        </p>
        }
      </form>
      }

      <p class="login-footer-cta">
        {{ 'Loginpage.new_here' | translate }}
        <a class="login-footer-link" href="https://snoball.events/book-demo3/" rel="noopener noreferrer" target="_blank">
          {{ 'Loginpage.book_chat' | translate }}
        </a>
      </p>
    </div>
  </div>

  <!-- Right: marketing (desktop) -->
  <div class="marketing-panel">
    <div class="marketing-gradient"></div>
    <div class="marketing-decoration marketing-decoration--1"></div>
    <div class="marketing-decoration marketing-decoration--2"></div>
    <div class="marketing-decoration marketing-decoration--3"></div>

    <app-login-network-visualization></app-login-network-visualization>

    <div class="marketing-content">
      <div class="marketing-pill">
        <span class="marketing-pill-icon" aria-hidden="true">❄</span>
        {{ 'Loginpage.marketing_badge' | translate }}
      </div>

      <h2 class="marketing-headline">
        {{ 'Loginpage.marketing_headline_1' | translate }}<br />
        <span class="marketing-headline-accent">{{ 'Loginpage.marketing_headline_2' | translate }}</span>
      </h2>

      <p class="marketing-sub">{{ 'Loginpage.marketing_sub' | translate }}</p>

      <div class="marketing-stats">
        <div class="stat-card">
          <div class="stat-card-value">
            {{ 'Loginpage.stat_1_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_1_unit' | translate }}</span>
          </div>
          <div class="stat-card-desc">{{ 'Loginpage.stat_1_desc' | translate }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-value">
            {{ 'Loginpage.stat_2_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_2_unit' | translate }}</span>
          </div>
          <div class="stat-card-desc">{{ 'Loginpage.stat_2_desc' | translate }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-card-value">
            {{ 'Loginpage.stat_3_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_3_unit' | translate }}</span>
          </div>
          <div class="stat-card-desc">{{ 'Loginpage.stat_3_desc' | translate }}</div>
        </div>
      </div>

      <p class="marketing-footnote">{{ 'Loginpage.marketing_footnote' | translate }}</p>
    </div>
  </div>
</div>
